"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initialize = initialize;
var pendoApiKey_1 = require("./pendoApiKey");
// This is installation settings provided by Pendo.
// The only modification that was done here is to pass in the apiKey and user object
// as function parameters and declare some variables as 'const' and 'let' to satisfy linter.
var pendoSnippet = function (apiKey, user, context) {
    (function (p, e, n, d) {
        var w, x;
        var o = (p[d] = p[d] || {});
        o._q = [];
        var v = ['initialize', 'identify', 'updateOptions', 'pageLoad'];
        for (w = 0, x = v.length; w < x; ++w)
            (function (m) {
                o[m] =
                    o[m] ||
                        function () {
                            o._q[m === v[0] ? 'unshift' : 'push'](
                            // eslint-disable-next-line prefer-rest-params
                            [m].concat([].slice.call(arguments, 0)));
                        };
            })(v[w]);
        var y = e.createElement(n);
        y.async = !0;
        y.src = 'https://cdn.pendo.io/agent/static/' + apiKey + '/pendo.js';
        var z = e.getElementsByTagName(n)[0];
        z.parentNode.insertBefore(y, z);
    })(window, document, 'script', 'pendo');
    // Call this whenever information about your visitors becomes available
    // Please use Strings, Numbers, or Bool for value types.
    pendo.initialize({
        visitor: __assign(__assign({}, context), { id: user.analyticsId, first_name: user.firstName, email: user.email }),
    });
};
function initialize(user, context) {
    if (context === void 0) { context = {}; }
    if (process.env.NODE_ENV !== 'test') {
        try {
            pendoSnippet(pendoApiKey_1.PENDO_API_KEY, user, context);
        }
        catch (error) {
            console.error(error);
        }
    }
}
